export default {"src":"/_next/static/media/AishaMoonwalk.3db1aef0.gif","height":100,"width":100,"blurWidth":0,"blurHeight":0};